import { Injectable, Type, Injector, Renderer2, ComponentRef, InjectionToken, ViewContainerRef } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { TableSettings } from '../models/table-settings.interface';

@Injectable()
export class ToolBarService {
    grid: AgGridAngular;
    public _toolbarElement: HTMLElement;
    public _activeToolbars: ComponentRef<any>[] = [];

    constructor(
        public _injector: Injector,
        public _renderer: Renderer2
    ) {
        this._createToolbar();
    }

    public attachGrid(grid: AgGridAngular) {
        this.grid = grid;
        const element = this.grid['_nativeElement'].firstChild;
        this._renderer.insertBefore(element, this._toolbarElement, element.firstChild);
    }

    public _createToolbar() {
        this._toolbarElement = this._renderer.createElement('div');
        this._renderer.setStyle(this._toolbarElement, 'width', '100%');
    }

	/**
	 * Adds toolbar components dynamically to the provided ViewContainerRef.
	 * Destroys any previously created toolbars.
	 * @param components Array of objects with { component: Type<any>, data: any }
	 * @param viewContainerRef The ViewContainerRef to insert toolbars into
	 */
	addToolbars(
		components: { component: Type<any>, data: any }[],
		viewContainerRef: ViewContainerRef
	) {
		if (!this.grid)
			return;

		this._activeToolbars.forEach(x => x.destroy());
		this._activeToolbars = [];

		viewContainerRef.clear();

		components.forEach(component => {
			const injector = this._createInjector(component.data);
			const componentRef = viewContainerRef.createComponent(component.component, { injector });
			componentRef.changeDetectorRef.detectChanges();
			this._activeToolbars.push(componentRef);
		});
	}

	public _createInjector(data): Injector {
		return Injector.create({
			providers: [{ provide: DATA_TABLE_TOOLBAR_DATA, useValue: data }],
			parent: this._injector
		});
	}
}

export const DATA_TABLE_TOOLBAR_DATA: InjectionToken<any> = new InjectionToken('data-table toolbar data');